import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { V3WebSocketProvider } from '../../providers/V3WebSocketProvider';
import Layout from './Layout';
import BackButtonListener from '../BackButtonListener';

const Main = () => {
  return (
    <>
      <Router>
      <BackButtonListener />
      <V3WebSocketProvider>
        <Layout />
        </V3WebSocketProvider>
      </Router>
    </>
  );
};

export default Main;
